// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const trendRankWrapper = "TrendRank__trendRankWrapper__gHOhK";
export const badgeWrapper = "TrendRank__badgeWrapper__LeSX3";
export const sliderWrapper = "TrendRank__sliderWrapper__Fjk-F";
export const title = "TrendRank__title__SxQVf";
export const hideRanking = "TrendRank__hideRanking__wXP+Q";
export const slideButton = "TrendRank__slideButton__Koih4";